import axios from "axios";
import { ApiBasicResponse } from "../../../../../models/apiBasicResponse.model";
import {CreateCreditTypeDto} from "../models/create-credit-type.models"
import {ApproveCreditDto} from "../models/approve-credit.models"

export const createCreditTypeService = async (data: CreateCreditTypeDto): Promise<ApiBasicResponse> => {  
    const url = process.env.REACT_APP_API_HOST + `credits/create-type-credit`;
    const responseWithAxios = await axios.post(url, data);
    return responseWithAxios.data;
}

export const updateTypeCreditStatusService = async (idCreditType:number,status:boolean):Promise<ApiBasicResponse> =>{
    const url = process.env.REACT_APP_API_HOST + `credits/update-type-credit-status/${idCreditType}/${status}`;
    const responseWithAxios = await axios.put(url);
    return responseWithAxios.data;
}

export const approveCreditService = async (data: ApproveCreditDto): Promise<ApiBasicResponse> => {
    const url = process.env.REACT_APP_API_HOST + `credits/approve-credit`;
    const responseWithAxios = await axios.put(url, data);
    return responseWithAxios.data;
}

export const disburseCreditService = async (idCredit:number,idClient:number): Promise<ApiBasicResponse> => {
    const url = process.env.REACT_APP_API_HOST + `credits/disburse-credit/${idCredit}/${idClient}`;
    const responseWithAxios = await axios.put(url);
    return responseWithAxios.data;
}

export const getCreditsGroupedByType = async (): Promise<ApiBasicResponse> => {
  const url = process.env.REACT_APP_API_HOST + `credits/grouped-by-type`;
  const responseWithAxios = await axios.get(url);
  return responseWithAxios.data; 
}

export const getActiveCreditTypesService = async (): Promise<ApiBasicResponse> => {
  const url = process.env.REACT_APP_API_HOST + `credits/get-Types-Credit`;
  const responseWithAxios = await axios.get(url);
  return responseWithAxios.data;
}

export const getFullInformationCreditService = async (idClient:number,idCredit:number):Promise<ApiBasicResponse> => {
    const url = process.env.REACT_APP_API_HOST + `credits/get-info-Credit/${idClient}/${idCredit}`;
    const responseWithAxios = await axios.get(url);
    return responseWithAxios.data; 
}

export const payCredit = async (idCredit:number, idClient:number, amountPay:number):Promise<ApiBasicResponse> => {
    const url = process.env.REACT_APP_API_HOST + `credits/pay-credit/${idCredit}/${idClient}/${amountPay}`;
    const responseWithAxios = await axios.post(url);
    return responseWithAxios.data;
}

export const declineCredit = async (data: ApproveCreditDto): Promise<ApiBasicResponse> => {
    const url = process.env.REACT_APP_API_HOST + `credits/decline-credit`;
    const responseWithAxios = await axios.post(url, data);
    return responseWithAxios.data;
} 